<div class="plan-draft-container">
  <app-tabs>
    <app-draft-tab [showActionButtons]="canApproveDrafts()"></app-draft-tab>
  </app-tabs>
</div>
